import RestService from "./restService";
import { BOARDING } from "../../url/hiring";
const singleton = Symbol();
const singletonEnforcer = Symbol();
/**
 *
 */
class BoardingService extends RestService {
  constructor(enforcer) {
    super(BOARDING);
    if (enforcer !== singletonEnforcer) throw new Error("Cannot construct Agency RestService more than one");
  }
  static get instance() {
    if (!this[singleton]) {
      this[singleton] = new BoardingService(singletonEnforcer);
    }
    return this[singleton];
  }
}

export default BoardingService;
